<button
  class="{{ `size-${size()}` }} {{ ICON_BUTTONS[variant()][color()] }}"
  [class.circle]="circle()"
  [class.pressed]="pressed()"
  [class.active]="active()"
  [class.disabled-active-hover]="disabledActiveHover()"
  [type]="actionType()"
  [tabindex]="tabindex()"
  [disabled]="disabled()"
>
  @if (icon(); as icon) {
    <onyx-icon [name]="icon" [size]="iconSize()"></onyx-icon>
  } @else {
    <ng-content></ng-content>
  }
</button>
